module.exports = __webpack_public_path__ + "static/favicon-df28507da13148d9a66842c6cbaf6f17.png";